import React, { useEffect, useRef, useState } from "react";
import { FaTrash } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BaseUrl from "../../base-api";
import Loader from "../Loader/Loader";
import { FaAngleLeft, FaAngleRight, FaPencil } from "react-icons/fa6";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { handleAxiosError } from "../Utility/handleAxiosError";
import { getPageNumbers } from "../Utility/pagination";

const Links = () => {
  const [images, setImages] = useState([]);
  const [locations, setLocations] = useState([]);
  const [newImage, setNewImage] = useState({
    location: "",
    designation: "",
    address: "",
    email: "",
    mobileNo: "",
    officeNo: "",
    name: "",
  });
  const fileInputRef = useRef(null);
  const token = sessionStorage.getItem("userToken");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
const dispatch = useDispatch();
  const [viewImages, setViewImages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
    const [currentImages, setCurrentImages] = useState(null);
    const [editTitle, setEditTitle] = useState("");
      const [currentEditId, setCurrentEditId] = useState("");
      const [isEditModalOpen, setIsEditModalOpen] = useState(false);
      const [designation, setDesignation] = useState([]);

  const [totalPages, setTotalPages] = useState(1);

  const fetchData = async (pageNumber = currentPage) => {
    setSearchQuery("");
    setCurrentPage(1);
    const token = sessionStorage.getItem("userToken");
    if (!token) return navigate("/login");
    const backendPage = pageNumber - 1;
   
    try {
      const resLocation = await AxiosInstance.get(`${BaseUrl}/api/master/district`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (resLocation.data.status === 200) {
        const locationTypes = resLocation.data.data.map((item) => item);
        setLocations(locationTypes);
      } else {
        toast.error("Failed to fetch locations.");
      }

      const resdesignation = await AxiosInstance.get(`${BaseUrl}/api/master/designation`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (resdesignation.data.status === 200) {
        const designationTypes = resdesignation.data.data.map((item) => item);
        setDesignation(designationTypes);
      } else {
        toast.error("Failed to fetch locations.");
      }

      const res = await AxiosInstance.post(
        `${BaseUrl}/api/officersDirectory/getAll`,
        { location: "All" },
        {
          params: {
            page: backendPage,
            size: itemsPerPage,
          },
        }
      );

      if (res.data.status === 200) {
        const processedImages = []
Object.entries(res.data.data.content).forEach(([district, entries]) => {
  entries.forEach(entry => {
    processedImages.push({
      ...entry,
      district: district || entry.district || 'N/A',
    });
  });
});
        setImages(processedImages);
        setTotalPages(res.data.data.totalPages);
        setTotalItems(res.data.data.totalItems);
        setCurrentPage(pageNumber);
      } else {
        toast.error(res.data.message || "Failed to load images.");
      }
    } catch (error) {
     handleAxiosError(error);
    } finally {
       dispatch(isloading(false));
    }
  };

  useEffect(() => {
     dispatch(isloading(true));
    fetchData();
  }, []);

  useEffect(() => {
    setViewImages(images.slice(0, itemsPerPage));
  }, [images]);

 const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      fetchData(pageNumber);
    }
  };

  const handleNextPage = () => {
    handlePageChange(currentPage + 1);
  };

  const handlePreviousPage = () => {
    handlePageChange(currentPage - 1);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        toast.error(
          "Invalid file type. Please upload an image in jpg, png or jpeg format"
        );
        fileInputRef.current.value = "";
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        toast.error("File size exceeds 1MB.");
        fileInputRef.current.value = "";
        return;
      }
      setNewImage({ ...newImage, file });
    }
  };

  const handleLocationChange = (e) => {
    setNewImage({ ...newImage, location: e.target.value });
  };
  const handledesigChange = (e) => {
    setNewImage({ ...newImage, designation: e.target.value });
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

   
    if (name === "mobileNo") {
      if (/^\d{0,10}$/.test(value)) {
        setNewImage({ ...newImage, [name]: value });
      }
    } 
     else if (name === "officeNo") {
      if (/^\d*$/.test(value)) {
        setNewImage({ ...newImage, [name]: value });
      }
    } 
  //   else if(name === "name"){
  //     if (/^[a-zA-Z\s]*$/.test(value)) {
  //     setNewImage({ ...newImage, [name]: value });
  //   }
  // }
   
     else{

      setNewImage({ ...newImage, [name]: value });
    }
  };

  const handleSave = async () => {
    if (
      !newImage.location ||
      !newImage.name ||
      !newImage.designation
    ) {
      toast.error("Please fill all required details.", {
        closeButton: "false",
      });
      return;
    }

   


    const formData = new FormData();
    formData.append("district", newImage.location);
    formData.append("name", newImage.name);
    formData.append("address", newImage.address);
    formData.append("mobileNo", newImage.mobileNo);
    formData.append("officeNo", newImage.officeNo);
    formData.append("designation", newImage.designation);
     dispatch(isloading(true));
    try {
      const res = await AxiosInstance.post(`${BaseUrl}/api/officersDirectory/create`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchData();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error uploading the image.");
    } finally {
      setNewImage({
        location: "",
        designation: "",
        address: "",
        mobileNo: "",
        officeNo: "",
        name: "",
      });
       dispatch(isloading(false));
    }
  };

  const handleDelete = async (id) => {
    const toastId = toast.warn(
      <div
        style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
      >
        <p>Are you sure you want to delete this image?</p>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-danger btn-sm mx-2"
            onClick={() => confirmDelete(id, toastId)}
          >
            Yes
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,

        // style: { width: "400px", minHeight: "220px" },
        closeButton: false,
      }
    );
  };

  const confirmDelete = async (id, toastId) => {
    toast.dismiss(toastId);
    toast.loading("Deleting image...", { position: "top-center" });
     dispatch(isloading(true));
    try {
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/officersDirectory/delete`,
        { key: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      toast.dismiss();
      if (res.data.status === 200) {
        toast.success(res.data.message, { position: "top-center" });

        fetchData();
      } else {
        toast.error(res.data.message, { position: "top-center" });
      }
    } catch (error) {
      toast.error("Error deleting image.", { position: "top-center" });
    } finally {
       dispatch(isloading(false));
    }
  };

  const handleEdit = (data) => {
    setCurrentImages(data);
    // setEditTitle(notification.title);
    // setCurrentEditId(id);
    setIsEditModalOpen(true);
  };

  useEffect(() => {
    return () => {
      images.forEach((img) => {
        if (img.imageUrl?.startsWith("blob:")) {
          URL.revokeObjectURL(img.imageUrl);
        }
      });
    };
  }, [images]);

  const handleSearch = (e) => {
    const query = e.target.value?.toLowerCase();
    setSearchQuery(query);

    const filteredLinks = images.filter((link) =>
      link.location?.toLowerCase().includes(query)||
    link.designation?.toLowerCase().includes(query) ||
    link.name?.toLowerCase().includes(query) ||
    link.address?.toLowerCase().includes(query) ||
    link.mobileNo?.toLowerCase().includes(query) ||
    link.officeNo?.toLowerCase().includes(query) ||
    link.email?.toLowerCase().includes(query) 
    );

    setTotalItems(filteredLinks.length);
    setCurrentPage(1);
    setViewImages(filteredLinks.slice(0, itemsPerPage));
  };

  const handleEditSave = async () => {
    if (!currentImages.district ||
        !currentImages.name ||
        // !currentImages.email ||
        !currentImages.designation) {
      toast.error("Fill All required Fields.");
      return;
    }

    

    const token = sessionStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("key", currentImages.key);
    formData.append("district", currentImages.district);
    formData.append("name", currentImages.name);
    formData.append("address", currentImages.address);
    formData.append("mobileNo", currentImages.mobileNo);
    formData.append("designation", currentImages.designation);
    formData.append("officeNo", currentImages.officeNo);
   
     dispatch(isloading(true));
    try {
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/officersDirectory/update`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchData(); 
        setIsEditModalOpen(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error updating the Directory.");
    } finally {
       dispatch(isloading(false));
    }
  };

  return (
    
        <div className="home-dashboard">
          <div className="ticket-tab">
            <h3>Upload Officers And Employees</h3>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">
                  District
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <select
                  className="form-select"
                  value={newImage.location}
                  onChange={handleLocationChange}
                >
                  <option value="">Select District</option>
                  {locations.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  Designation
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <select
                  className="form-select"
                  value={newImage.designation}
                  onChange={handledesigChange}
                >
                  <option value="">Select Designation</option>
                  {designation.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Name of Employee
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={newImage.name}
                  onChange={handleInputChange}
                  placeholder="Enter Name"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Address of Employee
                 
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  value={newImage.address}
                  onChange={handleInputChange}
                  placeholder="Enter Address"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Mobile Number(R)
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="mobileNo"
                  value={newImage.mobileNo}
                  onChange={handleInputChange}
                  placeholder="Enter Mobile Number"
                />
              </div>
             <div className="col-md-6 mt-4">
                <label className="form-label">
                  Contact Number(O)
                 
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="officeNo"
                  value={newImage.officeNo}
                  onChange={handleInputChange}
                  placeholder="Enter Contact Number"
                />
              </div>
              <div className="col-md-2 mt-3">
                <button
                  type="button"
                  className="btn btn-success mt-2"
                  onClick={handleSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
          {/* <hr style={{  height: "2px", backgroundColor: "green", margin:"4% 0"}} /> */}
          <div className="ticket-tab">
            <div className="row mb-4">
              <div className="col-6">
                <h3>Manage Officers And Employees</h3>
              </div>

              <div className="col-6">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by district, designation, name, number..."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
            </div>
            <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>District</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Address</th>
                  <th>Contact Number</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {viewImages.length > 0 ? (
                  viewImages.map((img) => (
                    <tr key={img.id}>
                      <td>{img.district}</td>
                      <td>
                         {img.name}
                      </td>
                      <td>{img.designation}</td>
                      <td>
                         {img.address}
                      </td>
                      
                      <td>
                        {img.mobileNo}, <br />
                        {img.officeNo}
                      </td>
                      <td>
                        <FaPencil
                          className="me-2"
                          style={{ cursor: "pointer", color: "orange" }}
                          onClick={() => handleEdit(img)}
                        />
                        <FaTrash
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() => handleDelete(img.id)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No Data Found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
           

             <div className="row mt-4" style={{ "--bs-gutter-x": "0rem" }}>
                        <div className="col-5">
                          {totalItems > 0
                            ? `Showing ${startIndex + 1}-${endIndex} of ${totalItems}`
                            : "No items to display"}
                        </div>
                        <div className="col-7 d-flex justify-content-end">
                          <div className="d-flex align-items-center">
                            <button
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                              }}
                              className="btn btn-success d-flex align-items-center justify-content-center"
                              onClick={handlePreviousPage}
                              disabled={currentPage === 1}
                            >
                              <FaAngleLeft />
                            </button>
            
                            <div className="mx-3 d-flex">
                              {getPageNumbers(currentPage, totalPages).map(
                                (pageNum, index) =>
                                  pageNum === "..." ? (
                                    <span key={`ellipsis-${index}`} className="mx-1">
                                      ...
                                    </span>
                                  ) : (
                                    <button
                                      key={pageNum}
                                      className={`btn mx-1 ${
                                        currentPage === pageNum
                                          ? "active btn-primary"
                                          : "btn-light"
                                      }`}
                                      onClick={() => handlePageChange(pageNum)}
                                    >
                                      {pageNum}
                                    </button>
                                  )
                              )}
                            </div>
            
                            <button
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                              }}
                              className="btn btn-success d-flex align-items-center justify-content-center"
                              onClick={handleNextPage}
                              disabled={currentPage >= totalPages}
                            >
                              <FaAngleRight />
                            </button>
                          </div>
                        </div>
                      </div>
            </div>
          </div>

          <Modal
            isOpen={isEditModalOpen}
            toggle={() => setIsEditModalOpen(false)}
            centered size="lg"
          >
            <ModalHeader toggle={() => setIsEditModalOpen(false)}>
              Edit Directory
            </ModalHeader>
            <ModalBody>
                
             
              <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">
                  District
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <select
                  className="form-select"
                  value={currentImages?.district || ""}
                  onChange={(e) =>
                    setCurrentImages((prev) => ({
                      ...prev,
                      location: e.target.value,
                    }))
                  }
                >
                  <option value="">Select District</option>
                  {locations.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  Designation
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <select
                  className="form-select"
                  value={currentImages?.designation || ""}
                 
                  onChange={(e) =>
                    setCurrentImages((prev) => ({
                      ...prev,
                      designation: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Designation</option>
                  {designation.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Name of Employee
                  <span style={{ color: "red", fontSize: "1rem" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={currentImages?.name}
                  onChange={(e) =>
                    setCurrentImages((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  placeholder="Enter Name"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Address of Employee
                  
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  value={currentImages?.address}
                  onChange={(e) =>
                    setCurrentImages((prev) => ({
                      ...prev,
                      address: e.target.value,
                    }))
                  }
                  placeholder="Enter Address"
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">
                  Mobile Number(R)
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="mobileNo"
                  value={currentImages?.mobileNo}
                  onChange={(e) =>
                    setCurrentImages((prev) => ({
                      ...prev,
                      mobileNo: e.target.value,
                    }))
                  }
                  placeholder="Enter Mobile Number"
                />
              </div>
             <div className="col-md-6 mt-4">
                <label className="form-label">
                  Contact Number(O)
                  
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="officeNo"
                  value={currentImages?.officeNo}
                  onChange={(e) =>
                    setCurrentImages((prev) => ({
                      ...prev,
                      officeNo: e.target.value,
                    }))
                  }
                  placeholder="Enter Contact Number"
                />
              </div>

            </div>

            </ModalBody>
            <ModalFooter className="flex-nowrap">
              <Button color="success" onClick={handleEditSave}>
                Save Changes
              </Button>
              <Button
                color="secondary"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>
    
  );
};

export default Links;
